import script from "./DiagnosticoFiscalRelatorio.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticoFiscalRelatorio.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticoFiscalRelatorio.vue?vue&type=style&index=0&id=8ddc191a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ddc191a"]])

export default __exports__